export const theme = {
  token: {
    colorPrimary: '#00CC00',
  },
};
